import { reverse } from 'named-urls'

import { routing } from '@utils/routing'

export const getTableRowLink = (row: any) => ({
  pathname: reverse(routing.contributions.orders.order.self, { orderId: row.id }),
  search: location.search,
})
